import PropTypes from 'prop-types'
import Tooltip from 'components/tooltip/Tooltip'

import { days, koreanMap } from 'components/TimeTable'

const WeeklyScheduleTooltip = ({ weeklySchedule }) => {
  const splits = weeklySchedule.split(' ')
  return (
    <Tooltip
      position="top center"
      nowrap={false}
      content={
        <>
          <strong className="tit_tooltip">설정 요일/시간</strong>
          {splits.map((bit, index) => {
            if (bit === '000000000000000000000000') {
              return null
            }
            const day = days[index]
            const korean = koreanMap[days[index]]
            let start
            let end
            const times = [...bit].reduce((accumulator, v, i) => {
              if (v === '1') {
                if (start === undefined) {
                  start = String(i).padStart(2, '0')
                }
                end = String(i + 1).padStart(2, '0')
                if (i === bit.length - 1) {
                  accumulator.push(`${start}시~${end}시`)
                }
              } else if (v === '0') {
                if (start !== undefined && end !== undefined) {
                  accumulator.push(`${start}시~${end}시`)
                }
                start = undefined
                end = undefined
              }
              return accumulator
            }, [])
            return (
              <p className="txt_tooltip" key={day}>
                <span className="info_day">- {korean}: </span>
                {times.join(', ')}
              </p>
            )
          })}
        </>
      }>
      일부 요일/시간
    </Tooltip>
  )
}
WeeklyScheduleTooltip.propTypes = {
  weeklySchedule: PropTypes.string.isRequired,
}
export default WeeklyScheduleTooltip
